<template>
  <b-row>
    <b-col sm="8">
      <form method="POST">
        <b-card
          class="contenedor">
          <div slot="header">
            <strong>Producto</strong>
          </div>
          <b-row>
            <b-col sm="12">
              <b-form-group horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Ordenes:"
                            label-for="inputHorizontal"
              >
                <b-form-select v-model="selectedProductEt.id_orden"
                               :options="ordenes"
                               class="mb-3"
                               :disabled="disabledInputs"
                />
              </b-form-group>

              <b-form-group horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Nombre:"
                            label-for="inputHorizontal"
              >
                <b-form-textarea v-model="selectedProductEt.nombre"
                                 placeholder="Producto..."
                                 :rows="3"
                                 :max-rows="6"
                                 :disabled="disabledInputs"
                />
              </b-form-group>

              <b-form-group horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Componente activo principal:"
                            label-for="inputHorizontal"
              >
                <b-form-textarea v-model="selectedProductEt.componentesactivos"
                                 :rows="3"
                                 :max-rows="6"
                                 :disabled="disabledInputs"
                />
              </b-form-group>

              <b-row>
                <b-col>
                  <b-form-group horizontal
                                :label-cols="4"
                                breakpoint="md"
                                label="Idioma:"
                                label-for="inputHorizontal"
                  >
                    <b-form-select v-model="selectedProductEt.idioma"
                                   :options="idiomas"
                                   class="mb-3"
                                   :disabled="disabledInputs"
                    />
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group horizontal
                                :label-cols="4"
                                breakpoint="md"
                                label="Estado:"
                                label-for="inputHorizontal"
                  >
                    <b-form-select v-model="selectedProductEt.estado"
                                   :options="estados"
                                   class="mb-3"
                                   :disabled="disabledInputs"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-form-group horizontal
                                :label-cols="4"
                                breakpoint="md"
                                label="Fabricante:"
                                label-for="inputHorizontal"
                  >
                    <b-form-input v-model="selectedProductEt.proveedorfabricante"
                                  :disabled="disabledInputs"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Observacion:"
                            label-for="inputHorizontal"
              >
                <b-form-textarea placeholder="Observacion..."
                                 v-model="selectedProductEt.observacion"
                                 :rows="3"
                                 :max-rows="6"
                                 :disabled="disabledInputs"
                />
              </b-form-group>

              <b-row v-if="accion==='create'">
                <b-col>
                  <b-button style="display:block;margin:auto;"
                            size="sm"
                            variant="primary"
                            @click="guardarProducto()"
                  >
                    <i class="fa fa-floppy-o"/> Guardar
                  </b-button>
                </b-col>
              </b-row>
              <b-row v-if="accion!=='create' && selectedProductEt.finalizado == 0">
                <b-col>
                  <b-button style="display:block;margin:auto;"
                            size="sm" variant="primary"
                            @click="actualizaProducto(selectedProductEt.id)"
                  >
                    <i class="fa fa-refresh"/> Actualizar
                  </b-button>
                </b-col>
                <b-col v-if="selectedProductEt.finalizado == 0">
                  <b-button style="display:block;margin:auto;"
                            size="sm"
                            variant="danger"
                            @click="finalizaProducto"
                  >
                    <i class="fa fa-check-square-o"/> Finalizar
                  </b-button>
                  <label style="text-align:center;font-size:7pt;">Al finalizar el producto no se podra volver a editar el producto</label>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </form>
    </b-col>

    <!--ADJUNTOS-->
    <b-col sm="4" v-if="accion!=='create'">
      <Adjuntos></Adjuntos>
    </b-col>
  </b-row>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import Adjuntos from './adjuntos/Adjuntos.vue';
import loader from "../../containers/loader";
import {getAcls} from "../../plugins/acl";


export default {
  components: {
    Adjuntos
  },
  name: 'General',
  props: ['Id'],
  async created() {
    if (this.filtroEt.esAdmin) {
      this.selectedProductEt.finalizado = true;
    }
  },
  computed: {
    disabledInputs() {
      return this.selectedProductEt.finalizado == 0 ? false : true
    },
    ...mapState('productos_et', [
      'selectedProductEt',
      'estados',
      'control_existe',
      'ordenes',
      'accion',
      'filtroEt',
      'idiomas'
    ])
  },
  methods: {
    onSubmit() {
      (async () => {
        await this.Authentication().then(() => {
          if (this.status == true) {
            this.$router.go("/")
          }
        })
      })()
    },
    async guardarProducto() {

      this.limpiarAdjEt();
      this.limpiarAdjunto();

      await this.guardaProducto();
      this.$router.push("/productos_et/" + this.selectedProductEt.id + '/' + this.selectedProductEt.id_empresa);
    },
    finalizaProducto() {
      if (confirm("Seguro?")) {
        this.finalizarProducto();
      }
    },
    ...mapActions('adjuntos', [
      'getIdioma',
      'getTipo',
      'getEstadoFds',
      'getListadoAdj'
    ]),
    ...mapActions('productos_et', [
      'getEstados',
      'getExisteNoExiste',
      'guardaProducto',
      'actualizaProducto',
      'getProducto',
      'getOrdenes',
      'finalizarProducto',

    ]),
    ...mapMutations('productos_et', [
      'setAccion',
      'asignaEmpresa',
      'limpiarGeneral',
      'asignaEmpresa'
    ]),
    ...mapMutations('dashboard', [
      'load'
    ]),
    ...mapMutations('adjuntos_et', [
      'limpiarAdjEt',
      'limpiarAdjunto'
    ])

    
  }
}
</script>
